import * as React from "react";
const DownloadIcon = (props) => (
    <svg
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g
            clipPath="url(#a)"
            stroke="#008c95"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M2.667 11.334v1.333A1.333 1.333 0 0 0 4 14.001h8a1.333 1.333 0 0 0 1.333-1.334v-1.333m-8.666-4L8 10.667l3.333-3.333M8 2.666v8" />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M0 0h16v16H0z" />
            </clipPath>
        </defs>
    </svg>
);
export default DownloadIcon;
